import React from 'react'
import { DndProvider } from 'react-dnd'
import IconEditor from './IconEditor'
import { HTML5Backend } from "react-dnd-html5-backend";

const TextEditor = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <IconEditor />
    </DndProvider>
  )
}

export default TextEditor